import styled from 'styled-components';
import Text11 from '@sdk/components/ui/typography/Text11';

export const BillingFieldLabel = styled(Text11)`
  color: ${(props) => props.theme.colors.primaryText};
  font-weight: 700;
  margin-bottom: 5px;
  text-transform: uppercase;
  font-size: 11px;
`;
